// Type for the state of the snackbar reducer, which is an array of snackbar configurations
interface NavigateWarningReducerState {
    showWarning: boolean;
    shouldShowWarning: boolean;
    confirmCallback: (() => void) | undefined;
}

// Type for the actions that can be dispatched to the snackbar reducer
type NavigateWarningReducerAction =
    | {
          type: 'set_should_show_warning';
          payload: { shouldShowWarning: boolean };
      }
    | { type: 'cancel_navigation' }
    | { type: 'confirm_navigation' }
    | { type: 'trigger_warning'; payload: { confirmCallback: () => void } };

const navigateWarningReducer = (
    state: NavigateWarningReducerState,
    action: NavigateWarningReducerAction
): NavigateWarningReducerState => {
    switch (action.type) {
        case 'cancel_navigation':
            return {
                ...state,
                showWarning: false,
                confirmCallback: undefined,
            };
        case 'confirm_navigation':
            return {
                ...state,
                showWarning: false,
                shouldShowWarning: false,
                confirmCallback: undefined,
            };
        case 'set_should_show_warning':
            return {
                ...state,
                shouldShowWarning: action.payload.shouldShowWarning,
            };
        case 'trigger_warning':
            return {
                ...state,
                showWarning: true,
                confirmCallback: action.payload.confirmCallback,
            };
        default:
            return state;
    }
};

export { navigateWarningReducer };
export type { NavigateWarningReducerState, NavigateWarningReducerAction };
